
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as dev5_Txcd_WuI4LNAd06MRS32F9_Fq8NLbHn8pABT_45omawMeta } from "/portal-nuxt-app/pages/dev.vue?macro=true";
import { default as _91_46_46_46slug_93A3dwaUortu8Se184IM6N1wx_45cdaKN5RRp6rbB_myFXwMeta } from "/portal-nuxt-app/pages/[...slug].vue?macro=true";
import { default as indexnhAchc4eTMmQQqP7Hhki_45X5d2d7gIzfnpGjVPEq22JoMeta } from "/portal-nuxt-app/pages/guest/index.vue?macro=true";
import { default as indexTGeDPJ2TqDQvWxhELBNLpJwzt7lsuRfcO27R2TLmtxYMeta } from "/portal-nuxt-app/pages/search/index.vue?macro=true";
import { default as booking2oSp3AIHUCc4oNSdxJihvawz6x3hjqGz3mjX1dEYiJEMeta } from "/portal-nuxt-app/pages/guest/booking.vue?macro=true";
import { default as profilewVrQGaD7WZDZyCWKXLSFfmNmApuDl7wVTU1iYdyc_45cYMeta } from "/portal-nuxt-app/pages/guest/profile.vue?macro=true";
import { default as _91key_93vPc2fgOyzN_450jQs7bPXDTjWX9_45Fz59DXWHmG6JQfNAAMeta } from "/portal-nuxt-app/pages/wishlist/[key].vue?macro=true";
import { default as indexf3teL3eTU5RsHhP84_7G2fNn1MYV5KquW_45PzVunGuZsMeta } from "/portal-nuxt-app/pages/wishlist/index.vue?macro=true";
import { default as indexykZyiHy3n7zSXY9DjrzoCv4fN9mMhMO3U7A_cEGOimgMeta } from "/portal-nuxt-app/pages/lastminute/index.vue?macro=true";
import { default as _91key_93BOc5f5fY6FHc_45ApJkUSMQwKV3V8QOWFRXSYJXPZntwUMeta } from "/portal-nuxt-app/pages/newsletter/[key].vue?macro=true";
import { default as indexIQuUYVDZcdTZFNdy6DOOeJtMuUM76bYBgVpTcakGfdMMeta } from "/portal-nuxt-app/pages/newsletter/index.vue?macro=true";
import { default as _91params_93id6TVlpNne8G6OD66eaSuFfs1CEM_QKiA_45Ltg72owK8Meta } from "/portal-nuxt-app/pages/search/p/[params].vue?macro=true";
import { default as page18_NbChlXF2Abd68s_92phPLkLOxygLJa9Nxf7a3dfUQMeta } from "/portal-nuxt-app/pages/dev-playground/page1.vue?macro=true";
import { default as page2n5yHf39z9nkhifIBFIJ48wy5ozcN_dTiUgPSJa64_gAMeta } from "/portal-nuxt-app/pages/dev-playground/page2.vue?macro=true";
import { default as _91currentPage_93imvYcxtf2Sli82fuFIzAXBIpZ40lElgV1U6nSUgLqMEMeta } from "/portal-nuxt-app/pages/search/[currentPage].vue?macro=true";
import { default as _91params_93OWdVuQ8B9S3muz0BMh23MftjChTaQSndjv6uz4v_45T1MMeta } from "/portal-nuxt-app/pages/lastminute/p/[params].vue?macro=true";
import { default as indexF70BUVK2Dwi_HTTSx_cROwB6UaaI51xzCsFSfHibIt4Meta } from "/portal-nuxt-app/pages/objektbewertung/index.vue?macro=true";
import { default as counter_q12Xunu6We7Rp6eveLUNRGB4Lm5U3ig6uITLzmL9SIMeta } from "/portal-nuxt-app/pages/dev-playground/counter.vue?macro=true";
import { default as pageRuesUzgcljoeq4RGJydeVD2xN76ghBy_45Nz2Dpqup2zDx28IMeta } from "/portal-nuxt-app/pages/dev-playground/pageRues.vue?macro=true";
import { default as tailwindbL1jxF5RWE_LeWjkq0NZgomQt9n3MaaF4jxTfAVSnVQMeta } from "/portal-nuxt-app/pages/dev-playground/tailwind.vue?macro=true";
import { default as _91currentPage_93I3aZrF_CMaySvRQVYtPTthk1EfgV9XzOY_bPjy0zjYUMeta } from "/portal-nuxt-app/pages/lastminute/[currentPage].vue?macro=true";
import { default as _91_46_46_46slug_93QfgRrWu6XTgRy_gLZ8l1qmxAbJBCQCqCHHr0qLtOoycMeta } from "/portal-nuxt-app/pages/mietwagen/danke/[...slug].vue?macro=true";
import { default as pageProductqk_4swqSXapZWmrvTBkMTd0qjpV7_45MD7XJ7IhLSxo4UMeta } from "/portal-nuxt-app/pages/dev-playground/pageProduct.vue?macro=true";
import { default as prerenderedqkgi7EkjFiFq7hQi9LSvug206tgI9HkR2ijAz2XE2zAMeta } from "/portal-nuxt-app/pages/dev-playground/prerendered.vue?macro=true";
import { default as _91inquiryId_93PkH3qN1U5M_3F5YeLAir21x0hUxVIgLRIajkIHCEUn4Meta } from "/portal-nuxt-app/pages/ext-inquiry-confirmation/[inquiryId].vue?macro=true";
export default [
  {
    name: "dev",
    path: "/dev",
    component: () => import("/portal-nuxt-app/pages/dev.vue")
  },
  {
    name: "slug",
    path: "/:slug(.*)*",
    component: () => import("/portal-nuxt-app/pages/[...slug].vue")
  },
  {
    name: "guest",
    path: "/guest",
    meta: { ...(indexnhAchc4eTMmQQqP7Hhki_45X5d2d7gIzfnpGjVPEq22JoMeta || {}), ...{"middleware":"guest-only"} },
    component: () => import("/portal-nuxt-app/pages/guest/index.vue")
  },
  {
    name: "search",
    path: "/search",
    meta: indexTGeDPJ2TqDQvWxhELBNLpJwzt7lsuRfcO27R2TLmtxYMeta || {},
    component: () => import("/portal-nuxt-app/pages/search/index.vue")
  },
  {
    name: "guest-booking",
    path: "/guest/booking",
    meta: { ...(booking2oSp3AIHUCc4oNSdxJihvawz6x3hjqGz3mjX1dEYiJEMeta || {}), ...{"middleware":"guest-only"} },
    component: () => import("/portal-nuxt-app/pages/guest/booking.vue")
  },
  {
    name: "guest-profile",
    path: "/guest/profile",
    meta: { ...(profilewVrQGaD7WZDZyCWKXLSFfmNmApuDl7wVTU1iYdyc_45cYMeta || {}), ...{"middleware":"guest-only"} },
    component: () => import("/portal-nuxt-app/pages/guest/profile.vue")
  },
  {
    name: "wishlist-key",
    path: "/wishlist/:key()",
    component: () => import("/portal-nuxt-app/pages/wishlist/[key].vue")
  },
  {
    name: "wishlist",
    path: "/wishlist",
    component: () => import("/portal-nuxt-app/pages/wishlist/index.vue")
  },
  {
    name: "lastminute",
    path: "/lastminute",
    meta: indexykZyiHy3n7zSXY9DjrzoCv4fN9mMhMO3U7A_cEGOimgMeta || {},
    component: () => import("/portal-nuxt-app/pages/lastminute/index.vue")
  },
  {
    name: "newsletter-key",
    path: "/newsletter/:key()",
    component: () => import("/portal-nuxt-app/pages/newsletter/[key].vue")
  },
  {
    name: "newsletter",
    path: "/newsletter",
    component: () => import("/portal-nuxt-app/pages/newsletter/index.vue")
  },
  {
    name: "search-p-params",
    path: "/search/p/:params()",
    meta: _91params_93id6TVlpNne8G6OD66eaSuFfs1CEM_QKiA_45Ltg72owK8Meta || {},
    component: () => import("/portal-nuxt-app/pages/search/p/[params].vue")
  },
  {
    name: "dev-playground-page1",
    path: "/dev-playground/page1",
    component: () => import("/portal-nuxt-app/pages/dev-playground/page1.vue")
  },
  {
    name: "dev-playground-page2",
    path: "/dev-playground/page2",
    meta: page2n5yHf39z9nkhifIBFIJ48wy5ozcN_dTiUgPSJa64_gAMeta || {},
    component: () => import("/portal-nuxt-app/pages/dev-playground/page2.vue")
  },
  {
    name: "search-currentPage",
    path: "/search/:currentPage()",
    meta: _91currentPage_93imvYcxtf2Sli82fuFIzAXBIpZ40lElgV1U6nSUgLqMEMeta || {},
    component: () => import("/portal-nuxt-app/pages/search/[currentPage].vue")
  },
  {
    name: "lastminute-p-params",
    path: "/lastminute/p/:params()",
    meta: _91params_93OWdVuQ8B9S3muz0BMh23MftjChTaQSndjv6uz4v_45T1MMeta || {},
    component: () => import("/portal-nuxt-app/pages/lastminute/p/[params].vue")
  },
  {
    name: "objektbewertung",
    path: "/objektbewertung",
    component: () => import("/portal-nuxt-app/pages/objektbewertung/index.vue")
  },
  {
    name: "dev-playground-counter",
    path: "/dev-playground/counter",
    component: () => import("/portal-nuxt-app/pages/dev-playground/counter.vue")
  },
  {
    name: "dev-playground-pageRues",
    path: "/dev-playground/pageRues",
    component: () => import("/portal-nuxt-app/pages/dev-playground/pageRues.vue")
  },
  {
    name: "dev-playground-tailwind",
    path: "/dev-playground/tailwind",
    component: () => import("/portal-nuxt-app/pages/dev-playground/tailwind.vue")
  },
  {
    name: "lastminute-currentPage",
    path: "/lastminute/:currentPage()",
    meta: _91currentPage_93I3aZrF_CMaySvRQVYtPTthk1EfgV9XzOY_bPjy0zjYUMeta || {},
    component: () => import("/portal-nuxt-app/pages/lastminute/[currentPage].vue")
  },
  {
    name: "mietwagen-danke-slug",
    path: "/mietwagen/danke/:slug(.*)*",
    component: () => import("/portal-nuxt-app/pages/mietwagen/danke/[...slug].vue")
  },
  {
    name: "dev-playground-pageProduct",
    path: "/dev-playground/pageProduct",
    component: () => import("/portal-nuxt-app/pages/dev-playground/pageProduct.vue")
  },
  {
    name: "dev-playground-prerendered",
    path: "/dev-playground/prerendered",
    component: () => import("/portal-nuxt-app/pages/dev-playground/prerendered.vue")
  },
  {
    name: "ext-inquiry-confirmation-inquiryId",
    path: "/ext-inquiry-confirmation/:inquiryId()",
    component: () => import("/portal-nuxt-app/pages/ext-inquiry-confirmation/[inquiryId].vue")
  }
]